module.exports = __webpack_public_path__ + "static/dice-2b10984d56dc4b5ad0213dc04be04471.gif";